import { useQuery } from '@tanstack/react-query'
import {
  getSelfLogsApi,
  getSelfLogStatsApi,
  getAllLogsApi,
  getLogStatsApi,
  type LogListParams,
  type LogStatParams,
} from '@/api/logs'

export function useSelfLogs(params: LogListParams, enabled = true) {
  return useQuery({
    queryKey: ['logs-self', params],
    queryFn: () => getSelfLogsApi(params),
    enabled,
  })
}

export function useSelfLogStats(params: LogStatParams, enabled = true) {
  return useQuery({
    queryKey: ['logs-self-stat', params],
    queryFn: () => getSelfLogStatsApi(params),
    enabled,
  })
}

export function useAllLogs(params: LogListParams, enabled = true) {
  return useQuery({
    queryKey: ['logs-all', params],
    queryFn: () => getAllLogsApi(params),
    enabled,
  })
}

export function useAllLogStats(params: LogStatParams, enabled = true) {
  return useQuery({
    queryKey: ['logs-all-stat', params],
    queryFn: () => getLogStatsApi(params),
    enabled,
  })
}
